import { render, staticRenderFns } from "./CompilationGuide.vue?vue&type=template&id=7d670064&scoped=true"
import script from "./CompilationGuide.vue?vue&type=script&lang=js"
export * from "./CompilationGuide.vue?vue&type=script&lang=js"
import style0 from "./CompilationGuide.vue?vue&type=style&index=0&id=7d670064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d670064",
  null
  
)

export default component.exports